module.exports = __webpack_public_path__ + "img/cert.1895b449.jpg";